<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
    <ToastContainer />
    <router-view />
  </div>
</template>

<script>
import ToastContainer from '@/modules/shared/components/ToastContainer.vue';

export default {
  name: 'App',
  components: {
    ToastContainer
  }
  // Você pode adicionar outras opções de Vue 2 aqui, se necessário
}
</script>

<style>
/* Adicione estilos globais aqui, se necessário */
</style>